import { render, staticRenderFns } from "./SRD.vue?vue&type=template&id=79ec3f3c"
import script from "./SRD.vue?vue&type=script&lang=js"
export * from "./SRD.vue?vue&type=script&lang=js"
import style0 from "./SRD.vue?vue&type=style&index=0&id=79ec3f3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports